<template>
  <PopupDialog
    v-model:open="open"
    :title="$t('source.no-source-selected')"
    :description="$t('source.force-select-description')"
    required
    content-class="bg-error text-error-content"
    backdrop-class="bg-error/50"
  >
    <template #actions>
      <CurrentSourceInfo class="ml-auto" />
    </template>
  </PopupDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useSource } from '../../stores/sourceStore';
import CurrentSourceInfo from '../source/CurrentSourceInfo.vue';
import PopupDialog from './PopupDialog.vue';

const { currentSource } = useSource();

const open = computed({
  get: () => currentSource.value === null,
  // The dialog is required, it can only be dismissed by selecting a source
  set: () => {},
});
</script>
